





















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class BeratBadan extends Vue {
  @Prop() setBb: string;
  @Prop() setLabel!: string;
  // bb = null;
  label = "";
  placeholder = this.setLabel;
  msg = "";
  validasi = [(v) => this.cek(v) || this.message()];
  // get alergi() {
  //   return this.setAlergi;
  // }
  // set alergi(value) {
  //   this.$emit("alergi", value);
  // }
  // @Watch("bb")
  // changeBb(v) {
  //   if (this.setLabel == "") {
  //     this.label = "";
  //     this.placeholder = "";
  //   } else {
  //     if (v == "" || v == null) {
  //       this.label = "";
  //       this.placeholder = this.setLabel;
  //     } else {
  //       this.label = this.setLabel;
  //       this.placeholder = "";
  //     }
  //   }
  //   console.log("bb ", v);

  //   this.$emit("bb", v);
  // }
  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setBb == "" || this.setBb == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }
  @Watch("setBb")
  changesetBb(v) {
    // console.log("setBb", v);
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (v == "" || v == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    // console.log("bb ", v);

    this.$emit("bb", v);
    this.setBb = v;
  }
  titik() {
    if (this.setBb) {
      this.setBb = this.setBb.split(",").join(".");
    }
  }
  cek(v) {
    if (this.setBb != null) {
      if (
        this.setBb.substring(this.setBb.length - 1, this.setBb.length) == ","
      ) {
        this.titik();
      } else if (isNaN(Number(this.setBb)))
        this.setBb = this.setBb.substring(0, this.setBb.length - 1);
      if (this.setBb.length > 5)
        this.setBb = this.setBb.substring(0, this.setBb.length - 1);
    }

    if (v == "" || v == null) {
      this.msg = "*Kolom Berat Badan harus diisi";
      return false;
    } else if (Number(v) > 300) {
      this.msg = "*Berat Badan " + v + " kg, Anda yakin?";
      return false;
    } else return true;
  }

  message() {
    return this.msg;
  }
}
